export enum TemplateFilterFormTypes {
    Name = 'name',
}